import { isMock } from "@myvp/shared/src/functions/mock"
import { graphqlClient } from "@myvp/shared/src/functions/request"
import { graphql } from "@myvp/todos/src/gql"
import {
  type GetUserVirtualTimeQuery,
  type Role,
} from "@myvp/todos/src/gql/graphql"

export const getUserVirtualTime = async (studyRoleContext: {
  studyId: string
  role: Role
  participantRelatedUserId: string
}): Promise<GetUserVirtualTimeQuery["getUserVirtualTime"]> => {
  if (!isMock()) {
    const query = graphql(/* GraphQL */ `
      query getUserVirtualTime($input: GetUserVirtualTimeInput!) {
        getUserVirtualTime(input: $input) {
          virtualTime {
            serverNow
            virtualNow
            paused
          }
        }
      }
    `)
    const result = await graphqlClient.request(query, {
      input: {
        studyRoleContext: {
          studyId: studyRoleContext.studyId,
          role: studyRoleContext.role,
          participantRelatedUserId: studyRoleContext.participantRelatedUserId,
        },
      },
    })
    return result.getUserVirtualTime
  } else {
    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.get("time-travel")?.toLowerCase() !== "true") {
      return { virtualTime: null }
    }
    const now = new Date().toISOString()
    return { virtualTime: { serverNow: now, virtualNow: now, paused: false } }
  }
}
